<div [ngClass]="{ 'select-document-component-inline': readOnly }"
     class="select-document-component">
    @switch (!!readOnly) {
        @case (false) {
            <div class="edit-contents">
                <div [ngClass]="{ 'form-control': useEditableDisplay }"
                     class="selection-display">
                    @switch (useEditableDisplay) {
                        @case (true) {
                            <i [adaptTooltip]="selectedStorageType?.getDisplayName()"
                               [ngClass]="selectedDocument?.getIconClass()"
                               class="storage-icon"></i>

                            <div class="display-url">
                                <a [href]="getAbsoluteUrl(selectedDocument?.getUrl() || '')"
                                   [ngClass]="{
                                        'line-through': !isCookiesEnabled,
                                    }"
                                   rel="noreferrer noopener"
                                   target="_blank">
                                    {{ selectedDocument?.getName() }}
                                </a>

                                @if (!isCookiesEnabled) {
                                    <i adaptTooltip="Please enable 3rd party cookies and refresh to access this link"
                                       class="fal fa-fw fa-exclamation error"></i>
                                }
                            </div>

                            <div class="display-buttons">
                                <button (click)="$event.preventDefault(); editLink()"
                                        [disabled]="selectionDisabled"
                                        adaptButtonIcon="edit"
                                        adaptTooltip="Edit link"
                                        class="btn btn-link edit-button"></button>

                                <button (click)="$event.preventDefault(); resetLink()"
                                        [disabled]="selectionDisabled"
                                        adaptButtonIcon="fal fa-times-circle"
                                        adaptTooltip="Clear link. Note: this will not delete the file"
                                        class="btn btn-link edit-button"></button>
                            </div>
                        }

                        @default {
                            <dx-text-box [(value)]="url"
                                         [disabled]="!isCustomUrlService(selectedStorageType)"
                                         class="flex-grow-1"
                                         placeholder="Enter location URL"> </dx-text-box>

                            <dx-select-box (onInitialized)="onSelectBoxInitialized($event)"
                                           (onContentReady)="onSelectBoxContentReady($event)"
                                           (onItemClick)="onStorageTypeSelected($event)"
                                           (onSelectionChanged)="onSelectionChanged($event)"
                                           [dataSource]="storageProviders"
                                           [grouped]="true"
                                           [disabled]="selectionDisabled || !isInitialised"
                                           [displayExpr]="storageDisplayExpr"
                                           [value]="selectedStorageType"
                                           [placeholder]="selectedStorageType ? selectedStorageType.getDisplayName() : 'Select location...'"
                                           class="selection-choices"
                                           groupTemplate="group">
                                <div *dxTemplate="let item of 'item'"
                                     class="dx-item-content dx-list-item-content">
                                    <i [ngClass]="item.getIconClass()"></i>
                                    {{ item.getDisplayName() }}
                                </div>
                            </dx-select-box>
                        }
                    }
                </div>
            </div>
        }

        @default {
            @if (selectedDocument?.getUrl() && selectedStorageType) {
                <div class="selected-document-container">
                    <i [adaptTooltip]="selectedStorageType.getDisplayName()"
                       [ngClass]="selectedDocument?.getIconClass()"></i>

                    <a [href]="getAbsoluteUrl(selectedDocument?.getUrl() || '')"
                       [ngClass]="{ 'line-through': !isCookiesEnabled }"
                       rel="noreferrer noopener"
                       target="_blank">
                        {{ selectedDocument?.getName() }}
                    </a>

                    @if (!isCookiesEnabled) {
                        <i adaptTooltip="Please enable 3rd party cookies and refresh to access this link"
                           class="fal fa-fw fa-exclamation error"></i>
                    }
                </div>
            }
        }
    }

    @if (selectionDisabled) {
        <div class="alert alert-info message"
             role="alert">
            <i class="fal fa-spinner fa-spin"
               aria-hidden="true"></i>
            {{ selectedStorageType?.getSelectionInProgressText() }}
        </div>
    }

    @if (errorMessage) {
        <div class="alert alert-danger message"
             role="alert">
            {{ errorMessage }}
        </div>
    }
</div>
